import { Link } from 'react-router-dom';

interface CategoryTabProps {
  slug: string;
  name: string;
  icon: string;
  description: string;
  color: string;
  isActive: boolean;
  linkCount?: number;
}

export default function CategoryTab({
  slug,
  name,
  icon,
  description,
  color,
  isActive,
  linkCount,
}: CategoryTabProps) {
  const colorMap: Record<string, { bg: string; text: string; border: string }> = {
    primary: {
      bg: 'bg-primary-100',
      text: 'text-primary-700',
      border: 'border-primary-300',
    },
    accent: {
      bg: 'bg-accent-100',
      text: 'text-accent-700',
      border: 'border-accent-300',
    },
    secondary: {
      bg: 'bg-secondary-100',
      text: 'text-secondary-700',
      border: 'border-secondary-300',
    },
  };

  const c = colorMap[color] || colorMap.primary;

  return (
    <Link
      to={`/category/${slug}`}
      className={`block no-underline p-4 rounded-lg border transition-all duration-300 ${
        isActive
          ? `${c.bg} ${c.border}`
          : 'border-background-200/70 bg-background-50 hover:border-background-300/60 hover:bg-background-100'
      }`}
    >
      <div className="flex items-center gap-3">
        <div
          className={`w-10 h-10 flex items-center justify-center rounded-lg ${
            isActive ? c.bg : 'bg-background-100'
          }`}
        >
          <i className={`${icon} text-lg ${isActive ? c.text : 'text-foreground-500'}`}></i>
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <h3 className={`font-heading text-base whitespace-nowrap ${
              isActive ? c.text : 'text-foreground-800'
            }`}>
              {name}
            </h3>
            {linkCount !== undefined && (
              <span className="text-xs text-foreground-500 whitespace-nowrap">
                {linkCount}个入口
              </span>
            )}
          </div>
          <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">
            {description}
          </p>
        </div>
        <i className={`ri-arrow-right-s-line text-xl ${
          isActive ? c.text : 'text-foreground-400'
        }`}></i>
      </div>
    </Link>
  );
}